angular
    .module('app')
    .component('b2bPartnersEdit', {
        templateUrl: '/templates/pages/b2bPartners/b2bPartnersEdit/b2bPartnersEdit.html',
        controller: 'B2bPartnersEditController',
        controllerAs: 'vm',
    });